import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../store/authSlice';
import { urlApiProduccion } from '../api/ApiRest';
import {
    Box, TextField, Button, MenuItem, Alert,
    InputAdornment, IconButton, CircularProgress, Typography
} from '@mui/material';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import './Login.css';

function Login() {
    const [nitCompany, setNitCompany] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [ambiente, setAmbiente] = useState('1');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const iniciarLogin = (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');

        fetch(urlApiProduccion + 'api/Login/Iniciar', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Nit: nitCompany,
                ambiente: ambiente,
                user: userName,
                password: password
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.status === true) {
                    localStorage.setItem('tokenSesion', response.token);
                    localStorage.setItem('tokenSesionInicio', response.sessionInicio);
                    localStorage.setItem('tokenSesionFin', response.sessionFin);
                    localStorage.setItem('AmbienteApiDian_Url', response.ambienteApi_Url);
                    localStorage.setItem('AmbienteTae_Url', urlApiProduccion);
                    localStorage.setItem('AdminTae', String(response.admin).toLowerCase());

                    dispatch(loginSuccess({
                        user: response.user,
                        token: response.token,
                        roles: response.roles_Results,
                        isAdmin: response.isAdmin,
                        company: response.empresa,
                        tokenSesion: response.token,
                        tokenSesionInicio: response.sessionInicio,
                        tokenSesionFin: response.sessionFin,
                        AmbienteApiDian_Url: response.ambienteApi_Url,
                        AmbienteTae_Url: urlApiProduccion,
                        AdminTae: String(response.admin).toLowerCase(),
                        CompanyId: response.companyId,
                        novedades: response.novedades_Results
                    }));

                    navigate(response.admin === true ? '/Home' : '/Home/Cliente');
                    window.location.reload();
                } else {
                    setError(response.msj);
                }
                setLoading(false);
            })
            .catch(() => {
                setError('Algo salió mal, por favor verifica tu conexión.');
                setLoading(false);
            });

        return false;
    };

    return (
        <Box className="login-root">
            {/* Panel izquierdo — marca */}
            <Box className="login-brand-panel">
                <img src="/TAE-COL BLANCO.png" alt="TAE-COL" className="login-logo" />
                <img src="/tav-saludando.gif" alt="TAV" className="login-mascot" />
                <Typography variant="h6" className="login-tagline">
                    Tu aliado electrónico en Colombia
                </Typography>
            </Box>

            {/* Panel derecho — formulario */}
            <Box className="login-form-panel">
                <Box component="form" onSubmit={iniciarLogin} className="login-form">
                    <Typography variant="h5" className="login-title">
                        Bienvenido
                    </Typography>
                    <Typography variant="body2" className="login-subtitle">
                        Ingresa tus credenciales para continuar
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <TextField
                        label="NIT Empresa"
                        variant="outlined"
                        fullWidth
                        required
                        size="small"
                        value={nitCompany}
                        autoComplete="off"
                        onChange={e => setNitCompany(e.target.value)}
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        label="Usuario (correo)"
                        variant="outlined"
                        fullWidth
                        required
                        size="small"
                        type="email"
                        value={userName}
                        autoComplete="off"
                        onChange={e => setUserName(e.target.value)}
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        label="Contraseña"
                        variant="outlined"
                        fullWidth
                        required
                        size="small"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        onClick={() => setShowPassword(prev => !prev)}
                                        edge="end"
                                    >
                                        {showPassword ? <AiOutlineEyeInvisible size={18} /> : <AiOutlineEye size={18} />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        label="Ambiente"
                        variant="outlined"
                        fullWidth
                        select
                        size="small"
                        value={ambiente}
                        onChange={e => setAmbiente(e.target.value)}
                        sx={{ mb: 1 }}
                    >
                        <MenuItem value="2">Test</MenuItem>
                        <MenuItem value="1">Producción</MenuItem>
                    </TextField>

                    <Box sx={{ textAlign: 'right', mb: 2 }}>
                        <a href="/Login/GestionarClave/vv" className="login-forgot">
                            ¿Olvidó su contraseña?
                        </a>
                    </Box>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={loading}
                        sx={{
                            background: '#224B6A',
                            fontWeight: 'bold',
                            py: 1.2,
                            '&:hover': { background: '#1a3a54' }
                        }}
                    >
                        {loading
                            ? <CircularProgress size={22} sx={{ color: '#fff' }} />
                            : 'INGRESAR'
                        }
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default Login;
